import { DriveDocuments } from "../DriveDocuments";
import { uid } from "../../lib/uid";

export function ExtrasSection({ form, set, customers, companyDocTitles, editingId, lrDocTypes }) {
  const getDoc = (t) => (form.company_docs || []).find((d) => d.title === t) || { title: t, number: "" };
  const setDocNumber = (t, number) => {
    const arr = (form.company_docs || []).filter((d) => d.title !== t);
    arr.push({ title: t, number });
    set("company_docs", arr);
  };
  return (
    <>
      <div>
        <div className="flex items-center justify-between mb-2">
          <div className="section-title mb-0">People &amp; Contacts</div>
          <div className="flex flex-wrap gap-2">
            {["Loading POC", "Unloading POC", "Driver", "Helper"].map((role) => (
              <button key={role} type="button" className="btn-ghost text-xs" onClick={() => set("contacts", [...(form.contacts || []), { role, name: "", phone: "", email: "", _uid: uid() }])} data-testid={`lr-add-contact-${role.replace(/\s+/g, "-").toLowerCase()}`}>+ {role}</button>
            ))}
            <button type="button" className="btn-ghost text-xs" onClick={() => set("contacts", [...(form.contacts || []), { role: "", name: "", phone: "", email: "", _uid: uid() }])} data-testid="lr-add-contact-custom">+ Custom</button>
          </div>
        </div>
        <p className="text-[11px] text-[#68665E] mb-2">Loading/unloading point contacts, driver, helper, or any other person. Nothing is required.</p>
        {(form.contacts || []).length === 0 ? (
          <div className="text-[11px] text-[#A09E96]">No contacts added.</div>
        ) : (form.contacts || []).map((c, i) => {
          const upd = (k, v) => { const arr = form.contacts.slice(); arr[i] = { ...arr[i], [k]: v }; set("contacts", arr); };
          return (
            <div key={c._uid ?? i} className="grid grid-cols-12 gap-2 mb-2 items-center" data-testid={`lr-contact-row-${i}`}>
              <input className="input-field col-span-3" placeholder="Role" value={c.role} onChange={(e)=>upd("role", e.target.value)} data-testid={`lr-contact-role-${i}`} />
              <input className="input-field col-span-3" placeholder="Name" value={c.name} onChange={(e)=>upd("name", e.target.value)} data-testid={`lr-contact-name-${i}`} />
              <input className="input-field col-span-2" placeholder="Phone" value={c.phone} onChange={(e)=>upd("phone", e.target.value)} data-testid={`lr-contact-phone-${i}`} />
              <input className="input-field col-span-3" placeholder="Email" value={c.email} onChange={(e)=>upd("email", e.target.value)} data-testid={`lr-contact-email-${i}`} />
              <button type="button" className="col-span-1 text-[#8A2526]" onClick={()=>set("contacts", form.contacts.filter((_,idx)=>idx!==i))} data-testid={`lr-contact-remove-${i}`}>×</button>
            </div>
          );
        })}
      </div>

      <div data-testid="lr-print-docs">
        <div className="section-title">Documents &amp; E-Way Bills <span className="text-[11px] font-normal text-[#68665E]">(printed on the LR — "As per Document No. …" + E-Way Bill numbers)</span></div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <div className="flex items-center justify-between mb-2">
              <label className="input-label mb-0">Document No(s). &amp; Date(s)</label>
              <button type="button" className="btn-ghost text-xs" onClick={() => set("documents", [...(form.documents || []), { number: "", date: "", _uid: uid() }])} data-testid="lr-add-document">+ Add Document</button>
            </div>
            {(form.documents || []).length === 0 ? (
              <div className="text-[11px] text-[#A09E96]">No document numbers. Click "+ Add Document".</div>
            ) : (form.documents || []).map((d, i) => {
              const upd = (k, v) => { const arr = form.documents.slice(); arr[i] = { ...arr[i], [k]: v }; set("documents", arr); };
              return (
                <div key={d._uid ?? i} className="flex gap-2 mb-2 items-center" data-testid={`lr-document-row-${i}`}>
                  <input className="input-field flex-1" placeholder="Document / order no." value={d.number} onChange={(e)=>upd("number", e.target.value)} data-testid={`lr-document-number-${i}`} />
                  <input type="date" className="input-field w-40" value={d.date || ""} onChange={(e)=>upd("date", e.target.value)} data-testid={`lr-document-date-${i}`} />
                  <button type="button" className="text-[#8A2526] px-1" onClick={()=>set("documents", form.documents.filter((_,idx)=>idx!==i))} data-testid={`lr-document-remove-${i}`}>×</button>
                </div>
              );
            })}
          </div>
          <div>
            <div className="flex items-center justify-between mb-2">
              <label className="input-label mb-0">E-Way Bill No(s). &amp; Date(s)</label>
              <button type="button" className="btn-ghost text-xs" onClick={() => set("ewaybills", [...(form.ewaybills || []), { number: "", date: "", _uid: uid() }])} data-testid="lr-add-ewaybill">+ Add E-Way Bill</button>
            </div>
            {(form.ewaybills || []).length === 0 ? (
              <div className="text-[11px] text-[#A09E96]">No e-way bills. Click "+ Add E-Way Bill".</div>
            ) : (form.ewaybills || []).map((e, i) => {
              const upd = (k, v) => { const arr = form.ewaybills.slice(); arr[i] = { ...arr[i], [k]: v }; set("ewaybills", arr); };
              return (
                <div key={e._uid ?? i} className="flex gap-2 mb-2 items-center" data-testid={`lr-ewaybill-row-${i}`}>
                  <input className="input-field flex-1 font-mono" placeholder="E-way bill no." value={e.number} onChange={(ev)=>upd("number", ev.target.value)} data-testid={`lr-ewaybill-number-${i}`} />
                  <input type="date" className="input-field w-40" value={e.date || ""} onChange={(ev)=>upd("date", ev.target.value)} data-testid={`lr-ewaybill-date-${i}`} />
                  <button type="button" className="text-[#8A2526] px-1" onClick={()=>set("ewaybills", form.ewaybills.filter((_,idx)=>idx!==i))} data-testid={`lr-ewaybill-remove-${i}`}>×</button>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div>
        <div className="flex items-center justify-between mb-2">
          <div className="section-title mb-0">Custom Details</div>
          <button type="button" className="btn-ghost text-xs" onClick={() => set("custom_fields", [...(form.custom_fields || []), { title: "", value: "" }])} data-testid="lr-add-custom-field">+ Add Field</button>
        </div>
        <p className="text-[11px] text-[#68665E] mb-2">Add any client-specific info (e.g. L&amp;T "LSO Number", BHEL work-order). Picking a saved customer auto-fills their fields.</p>
        {(form.custom_fields || []).length === 0 ? (
          <div className="text-[11px] text-[#A09E96]">No custom fields. Click "+ Add Field" or pick a customer with a template.</div>
        ) : (form.custom_fields || []).map((cf, i) => {
          const upd = (k, v) => { const arr = form.custom_fields.slice(); arr[i] = { ...arr[i], [k]: v }; set("custom_fields", arr); };
          return (
            <div key={cf._uid ?? i} className="grid grid-cols-12 gap-2 mb-2 items-center" data-testid={`lr-custom-field-${i}`}>
              <input list="lr-custom-field-titles" className="input-field col-span-5" placeholder="Title (e.g. LSO Number)" value={cf.title} onChange={(e)=>upd("title", e.target.value)} data-testid={`lr-custom-title-${i}`} />
              <input className="input-field col-span-6" placeholder="Value" value={cf.value} onChange={(e)=>upd("value", e.target.value)} data-testid={`lr-custom-value-${i}`} />
              <button type="button" className="col-span-1 text-[#8A2526]" onClick={()=>set("custom_fields", form.custom_fields.filter((_,idx)=>idx!==i))} data-testid={`lr-custom-remove-${i}`}>×</button>
            </div>
          );
        })}
        <datalist id="lr-custom-field-titles">
          {Array.from(new Set(customers.filter((c)=>[form.consignor_name, form.consignee_name, ...(form.pickups||[]).map(p=>p.company), ...(form.deliveries||[]).map(d=>d.company)].includes(c.name)).flatMap((c)=>c.field_labels||[]))).map((t)=><option key={t} value={t} />)}
        </datalist>
      </div>

      {companyDocTitles.length > 0 && (
        <div data-testid="lr-company-docs">
          <div className="section-title">Company Documents <span className="text-[11px] font-normal text-[#68665E]">(auto-shown for the selected company — internal, not on the LR PDF)</span></div>
          <p className="text-[11px] text-[#68665E] mb-2">Enter each document's number. {editingId ? "Upload the file itself in the Documents section below (pick the matching title)." : "Save the LR to also upload the files."}</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {companyDocTitles.map((t) => (
              <div key={t}>
                <label className="input-label">{t} — Number</label>
                <input className="input-field" value={getDoc(t).number} onChange={(e)=>setDocNumber(t, e.target.value)}
                  placeholder={`${t} number / reference`} data-testid={`lr-companydoc-${t.replace(/\s+/g, "-").toLowerCase()}`} />
              </div>
            ))}
          </div>
        </div>
      )}

      <div>
        <label className="input-label">Notes / Remarks <span className="text-[11px] font-normal text-[#68665E]">(prints on the LR)</span></label>
        <textarea rows={2} className="input-field" value={form.remarks} onChange={(e)=>set("remarks", e.target.value)} placeholder="Any note you want printed on the consignment note" data-testid="lr-remarks" />
      </div>

      {editingId ? (
        <div>
          <div className="section-title">Documents (Google Drive)</div>
          <p className="text-[11px] text-[#68665E] mb-3">Attach documents (EWB/AWB/INV/DC or any custom title). Stored in Drive under this LR number.</p>
          <DriveDocuments
            category="lr"
            refId={editingId}
            refLabel={form.lr_number || ""}
            docTypes={[...(lrDocTypes || []), ...companyDocTitles]}
          />
        </div>
      ) : (
        <div className="text-[11px] text-[#68665E] border border-dashed border-[#E5E3DB] px-4 py-3">
          Save the LR first to attach documents (EWB/AWB/INV/DC) to Google Drive.
        </div>
      )}
    </>
  );
}
